import { z } from 'zod';
/**
 * Request body accepted by the `POST /opensearch/reindex/legislative-items` endpoint.
 */
export const reindexLegislativeItemsBodySchema = z.object({
    /**
     * When provided, restricts the reindex to items belonging to this government.
     */
    governmentId: z.number().int().positive().optional(),
    /**
     * When `true`, restricts the reindex to items that have no `PROCESSED` outbox entry
     * for the `legislative_items` index — i.e. items that have never been successfully
     * synced to OpenSearch.
     */
    unprocessedOnly: z.boolean().optional(),
});
/**
 * Request body accepted by the `POST /opensearch/reindex/public-documents` endpoint.
 */
export const reindexPublicDocumentsBodySchema = z.object({
    /**
     * When provided, restricts the reindex to documents belonging to this government.
     */
    governmentId: z.number().int().positive().optional(),
    /**
     * When `true`, restricts the reindex to documents that have no `PROCESSED` outbox entry
     * for the `public_documents` index.
     */
    unprocessedOnly: z.boolean().optional(),
});
/**
 * Request body accepted by the `POST /opensearch/reindex/meeting-transcripts` endpoint.
 */
export const reindexMeetingTranscriptsBodySchema = z.object({
    /**
     * When provided, restricts the reindex to meetings belonging to this government.
     */
    governmentId: z.number().int().positive().optional(),
    /**
     * When `true`, restricts the reindex to meetings that have no `PROCESSED` outbox entry
     * for the `meeting_transcripts` index.
     */
    unprocessedOnly: z.boolean().optional(),
});
